import * as React from 'react'
import { Text } from '@aws-amplify/ui-react'

const ConfirmResetPassword = {
  Header: () => <Text>Code has been sent to your email</Text>
}

export default ConfirmResetPassword;
